import React from 'react';
import PropTypes from 'prop-types';

function NutritionPanelIngredients({ ingredients, className, labelClassName, valueClassName }) {
  if (!ingredients) {
    return null;
  }

  return (
    <div className={className}>
      <div className={labelClassName}>Ingredients</div>
      <div className={valueClassName}>{ingredients}</div>
    </div>
  );
}

NutritionPanelIngredients.propTypes = {
  ingredients: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  valueClassName: PropTypes.string,
};

NutritionPanelIngredients.defaultProps = {
  ingredients: null,
  className: 'd-flex justify-content-between',
  labelClassName: 'pr-2 text-nowrap',
  valueClassName: 'text-right',
};

export default NutritionPanelIngredients;
